import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';
import SEO from '../../seo';
import { PAGE_SEO, COMMON_KEYWORDS } from '../../seo/pageSeo';

const models = [
  {
    label: 'X6-160',
    width: '1600mm',
    specs: [
      { label: '最大面料重量', value: '80kg' },
      { label: '最大驱动速度', value: '88m/min' },
      { label: '功率', value: '1.2KW' },
      { label: '电源', value: '220V / 15A' },
    ],
  },
  {
    label: 'X6-190',
    width: '1900mm',
    specs: [
      { label: '最大面料重量', value: '80kg' },
      { label: '最大驱动速度', value: '88m/min' },
      { label: '功率', value: '1.2KW' },
      { label: '电源', value: '220V / 15A' },
    ],
  },
  {
    label: 'X6-210',
    width: '2100mm',
    specs: [
      { label: '最大面料重量', value: '80kg' },
      { label: '最大驱动速度', value: '88m/min' },
      { label: '功率', value: '1.2KW' },
      { label: '电源', value: '220V / 15A' },
    ],
  },
  {
    label: 'X6-260',
    width: '2600mm',
    specs: [
      { label: '最大面料重量', value: '110kg' },
      { label: '最大驱动速度', value: '85m/min' },
      { label: '功率', value: '1.55KW' },
      { label: '电源', value: '220V / 15A' },
    ],
  },
  {
    label: 'X6-310',
    width: '3100mm',
    specs: [
      { label: '最大面料重量', value: '110kg' },
      { label: '最大驱动速度', value: '85m/min' },
      { label: '功率', value: '1.55KW' },
      { label: '电源', value: '220V / 15A' },
    ],
  },
];

const modules = [
  {
    num: '01',
    name: '全能型设计',
    nameEn: 'All-Round Design',
    nameVi: 'Thiết kế toàn diện',
    description:
      'X6系列全能型铺布机，适用于多种面料处理，稳定可靠。高性能驱动系统配合精密张力调节，满足不同生产环境的需求。',
    descriptionEn:
      'X6 all-round spreader is suitable for various fabric processing with stable and reliable performance. High-performance drive system with precise tension adjustment meets diverse production requirements.',
    descriptionVi:
      'X6 là máy trải vải đa năng phù hợp với nhiều loại vải với hiệu suất ổn định và đáng tin cậy. Hệ thống truyền động hiệu suất cao với điều chỉnh lực căng chính xác đáp ứng nhu cầu sản xuất đa dạng.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_hero.webp',
    align: 'left',
  },
  {
    num: '02',
    name: '高效驱动',
    nameEn: 'Efficient Drive',
    nameVi: 'Truyền động hiệu quả',
    description:
      '强劲伺服驱动系统，最高88m/min驱动速度。低速大力矩输出，电子同步实时跟随，送布张力均匀稳定，生产效率大幅提升。',
    descriptionEn:
      'Powerful servo drive system with up to 88m/min speed. High torque at low speed with electronic synchronization for uniform and stable feed tension, significantly improving production efficiency.',
    descriptionVi:
      'Hệ thống truyền động servo mạnh mẽ với tốc độ lên đến 88m/phút. Mô-men xoắn cao ở tốc độ thấp với đồng bộ điện tử cho lực căng cấp đồng đều và ổn định, cải thiện đáng kể hiệu quả sản xuất.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module1.webp',
    align: 'right',
  },
  {
    num: '03',
    name: '伺服驱动',
    nameEn: 'Servo Drive',
    nameVi: 'Truyền động servo',
    description:
      '高精度伺服电机驱动，响应速度快，运行平稳，噪音低，使用寿命长，维护成本低。',
    descriptionEn:
      'High-precision servo motor drive with fast response, stable operation, low noise, long service life, and low maintenance cost.',
    descriptionVi:
      'Truyền động động cơ servo độ chính xác cao với phản hồi nhanh, vận hành ổn định, tiếng ồn thấp, tuổi thọ dài và chi phí bảo trì thấp.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module2.webp',
    align: 'left',
  },
  {
    num: '04',
    name: '大布斗',
    nameEn: 'Large Cloth Bucket',
    nameVi: 'Khay vải lớn',
    description:
      '大容积布斗设计，减少换布次数，提高连续作业效率，适合大批量生产需求。',
    descriptionEn:
      'Large-volume cloth bucket design reduces cloth change frequency and improves continuous production efficiency for high-volume requirements.',
    descriptionVi:
      'Thiết kế khay vải dung tích lớn giảm tần suất thay đổi vải và cải thiện hiệu quả sản xuất liên tục cho nhu cầu sản lượng lớn.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module3.webp',
    align: 'right',
  },
  {
    num: '05',
    name: '二次剥离',
    nameEn: 'Secondary Peeling',
    nameVi: 'Bóc tách hai lớp',
    description:
      '二次剥离技术，有效解决卷边面料的铺布难题，铺布平整无褶皱。',
    descriptionEn:
      'Secondary peeling technology effectively solves the spreading problem of rolled-edge fabrics, ensuring smooth and wrinkle-free spreading.',
    descriptionVi:
      'Công nghệ bóc tách hai lớp giải quyết hiệu quả vấn đề trải vải với mép cuộn, đảm bảo trải phẳng và không có nếp nhăn.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module4.webp',
    align: 'left',
  },
  {
    num: '06',
    name: '控制中心',
    nameEn: 'Control Center',
    nameVi: 'Trung tâm điều khiển',
    description:
      '集成化控制中心，人机界面友好，操作简便，支持多种工作模式切换。',
    descriptionEn:
      'Integrated control center with user-friendly interface, easy operation, and support for multiple working mode switching.',
    descriptionVi:
      'Trung tâm điều khiển tích hợp với giao diện thân thiện, vận hành dễ dàng và hỗ trợ chuyển đổi nhiều chế độ làm việc.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module5.webp',
    align: 'right',
  },
  {
    num: '07',
    name: '智能控制',
    nameEn: 'Intelligent Control',
    nameVi: 'Điều khiển thông minh',
    description:
      '智能控制系统，自动检测面料类型，实时调节参数，保证最佳铺布效果。',
    descriptionEn:
      'Intelligent control system automatically detects fabric type and adjusts parameters in real time to ensure optimal spreading results.',
    descriptionVi:
      'Hệ thống điều khiển thông minh tự động phát hiện loại vải và điều chỉnh thông số theo thời gian thực để đảm bảo kết quả trải vải tối ưu.',
    imageUrl: 'https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_module6.webp',
    align: 'left',
  },
];

function X6ModelCard({ model, index, t }) {
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={cardRef}
      className="x6-model-card"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="x6-model-card__label">{model.label}</div>
      <div className="x6-model-card__width">{model.width}</div>
      <div className="x6-model-card__divider" />
      <ul className="x6-model-card__specs">
        {model.specs.map((spec, i) => (
          <li key={i}>
            <strong>{spec.value}</strong>
            {t(spec.labelKey)}
          </li>
        ))}
      </ul>
    </div>
  );
}

function X6ModuleItem({ module, index, getModuleText }) {
  const itemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const moduleName = getModuleText(module, 'name');
  const moduleDesc = getModuleText(module, 'description');

  return (
    <div
      ref={itemRef}
      className={`x6-module-item x6-module-item--${module.align}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="x6-module-item__media">
        <img
          src={module.imageUrl}
          alt={moduleName}
          className="x6-module-item__img"
          loading="lazy"
        />
        <div className="x6-module-item__badge">
          <span>{module.num}</span>
        </div>
      </div>

      <div className="x6-module-item__body">
        <div className="x6-module-item__num">
          {module.num} / {modules.length.toString().padStart(2, '0')}
        </div>
        <h3 className="x6-module-item__name">
          {moduleName}
          <br />
          <span style={{ fontSize: '0.55em', color: 'var(--color-primary)', fontWeight: 700 }}>
            {getModuleText(module, 'nameEn')}
          </span>
        </h3>
        <div className="x6-module-item__divider" />
        <p className="x6-module-item__desc">{moduleDesc}</p>
      </div>
    </div>
  );
}

export default function X6Machine() {
  const { t, i18n } = useTranslation();

  const getModuleText = (module, field) => {
    const lang = i18n.language;
    if (lang.startsWith('vi')) return module[`${field}Vi`] || module[`${field}`] || module[`${field}En`];
    if (lang.startsWith('en')) return module[`${field}En`] || module[`${field}`];
    return module[field];
  };

  const getSpecLabelKey = (index) => {
    const keys = ['product_max_fabric_weight', 'product_max_drive_speed', 'product_power', 'product_power_source'];
    return keys[index] || 'product_max_fabric_weight';
  };

  const modelsWithSpecKeys = models.map(m => ({
    ...m,
    specs: m.specs.map((s, i) => ({ ...s, labelKey: getSpecLabelKey(i) }))
  }));

  return (
    <>
    <SEO
        pageKey="x6"
        title={PAGE_SEO.x6.title}
        description={PAGE_SEO.x6.description}
        keywords={COMMON_KEYWORDS}
        slug={PAGE_SEO.x6.slug}
    />
    <div className="x6-page">
      {/* Hero */}
      <div className="x6-hero">
        <img
          className="x6-hero__img"
          src="https://oss.xiaomaizn.com/xiaomai/xiaomai官网/files/images/products/x6_hero.webp"
          alt="X6 Series"
        />
        <div className="x6-hero__overlay" />
        <div className="x6-hero__content">
          <div className="x6-hero__eyebrow">
            {t('x6_hero_eyebrow')}
          </div>
          <h1 className="x6-hero__title">{t('x6_hero_title')}</h1>
          <p className="x6-hero__sub">
            {t('x6_hero_sub')}
          </p>
          <div className="x6-hero__rule" />
        </div>
      </div>

      {/* Specs Section */}
      <section className="x6-specs-section">
        <div className="x6-section-header">
          <div className="x6-section-eyebrow">
            {t('x6_specs_eyebrow')}
          </div>
          <h2 className="x6-section-title">
            {t('x6_specs_title')}
          </h2>
          <div className="x6-section-rule" />
        </div>

        <div className="x6-model-cards">
          {modelsWithSpecKeys.map((model, index) => (
            <X6ModelCard key={model.label} model={model} index={index} t={t} />
          ))}
        </div>
      </section>

      {/* Module Showcase */}
      <section className="x6-modules-section">
        <div className="x6-section-header">
          <div className="x6-section-eyebrow">
            {t('x6_modules_eyebrow')}
          </div>
          <h2 className="x6-section-title">
            {t('x6_modules_title')}
          </h2>
          <div className="x6-section-rule" />
        </div>

        {modules.map((module, index) => (
          <X6ModuleItem key={module.num} module={module} index={index} getModuleText={getModuleText} />
        ))}
      </section>

      {/* CTA */}
      <div className="x6-cta">
        <div className="x6-cta__inner">
          <p className="x6-cta__text">
            {t('x6_cta_text')}
            <br />
            <span className="x6-cta__accent">
              {t('x6_cta_accent')}
            </span>
          </p>
          <p className="x6-cta__sub">
            {t('x6_cta_sub')}
          </p>
        </div>
      </div>
    </div>
    </>
  );
}
